/* EB Frequently Bought Together - cart page. LIVE + Funnel Build 2026-10-21.
   Full-row companion to the drawer strip (assets/eb-funnel.js): reads the
   cart, loads the same precomputed root part number sibling map
   (assets/eb-sibling-map-1..8.js -> window.EB_SIBLING_MAP), and renders
   the FULL sibling family of EVERY cart item - union across items,
   deduped, family members already in the cart not re-suggested - as
   complete product rows. Each row fetches its product's live variants and
   renders the standard [data-eb-qo] quick-add block (labels + selects +
   Add) powered by assets/eb-quick-order.js, which keeps Add disabled
   until a complete, available variant combination is chosen - the
   no-default rule. If the variant fetch fails, the row degrades to
   image/title/price linking to the product page.
   Re-syncs when the ajax cart drawer content changes (any add from this
   page refreshes the drawer), so an item just added drops out of the
   suggestions. Render state is stamped on the container (data-eb-sig). */
(function () {
  'use strict';

  var mapState = 0; /* 0 = not requested, 1 = loading, 2 = ready, 3 = failed */
  var syncing = false;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureMap(box, cb) {
    if (mapState === 2) { cb(true); return; }
    if (mapState === 3) { cb(false); return; }
    if (mapState === 1) {
      var t = setInterval(function () {
        if (mapState === 2) { clearInterval(t); cb(true); }
        if (mapState === 3) { clearInterval(t); cb(false); }
      }, 150);
      setTimeout(function () { clearInterval(t); }, 10000);
      return;
    }
    mapState = 1;
    var base = box.getAttribute('data-map-url');
    var count = parseInt(box.getAttribute('data-map-parts'), 10) || 1;
    var jobs = [];
    for (var n = 1; n <= count; n++) {
      jobs.push(loadScript(base.replace('eb-sibling-map-1', 'eb-sibling-map-' + n)));
    }
    Promise.all(jobs).then(function () {
      mapState = 2;
      cb(!!window.EB_SIBLING_MAP);
    }).catch(function () {
      mapState = 3;
      cb(false);
    });
  }

  function rowHTML(sib, productJs) {
    var h = '<div class="eb-fbt__row">';
    h += '<a class="eb-fbt__imglink" href="/products/' + esc(sib.h) + '">';
    if (sib.im) h += '<img src="' + esc(sib.im + '?width=400') + '" alt="' + esc(sib.t) + '" loading="lazy">';
    h += '</a>';
    h += '<div class="eb-fbt__info">';
    h += '<a class="eb-fbt__name" href="/products/' + esc(sib.h) + '">' + esc(sib.t) + '</a>';
    h += '<div class="eb-fbt__price">' + money(sib.p) + '</div>';
    if (productJs) {
      var variants = productJs.variants.map(function (v) {
        return { i: v.id, o: v.options, a: !!v.available, p: v.price };
      });
      var onlyDefault = productJs.options.length === 1 && productJs.options[0].name === 'Title';
      h += '<div class="eb-qo" data-eb-qo>';
      if (!onlyDefault) {
        productJs.options.forEach(function (opt, idx) {
          h += '<label class="eb-qo__label"><span class="eb-qo__label-text">' + esc(opt.name) + '</span>';
          h += '<select class="eb-qo__select" data-eb-qo-select data-option-index="' + idx + '" aria-label="' + esc(opt.name) + '">';
          h += '<option value="">Select ' + esc(opt.name) + '</option>';
          opt.values.forEach(function (val) {
            h += '<option value="' + esc(val) + '">' + esc(val) + '</option>';
          });
          h += '</select></label>';
        });
      }
      h += '<script type="application/json" data-eb-qo-variants>' + JSON.stringify(variants) + '<\/script>';
      h += '<button type="button" class="eb-qo__add button" data-eb-qo-add disabled>Add to Cart</button>';
      h += '<p class="eb-qo__msg" data-eb-qo-msg hidden></p>';
      h += '</div>';
    }
    h += '</div></div>';
    return h;
  }

  function renderSiblings(box, sibs, sig) {
    box.setAttribute('data-eb-sig', sig);
    var rows = box.querySelector('[data-eb-fbt-rows]');
    var jobs = sibs.map(function (sib) {
      return fetch('/products/' + sib.h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (pjs) { return rowHTML(sib, pjs); });
    });
    Promise.all(jobs).then(function (html) {
      if (box.getAttribute('data-eb-sig') !== sig || !document.contains(box)) return;
      rows.innerHTML = html.join('');
      box.hidden = false;
      if (window.EBQuickOrder) window.EBQuickOrder.refreshAll(box);
    });
  }

  function clearBox(box) {
    box.removeAttribute('data-eb-sig');
    var rows = box.querySelector('[data-eb-fbt-rows]');
    if (rows) rows.innerHTML = '';
    box.hidden = true;
  }

  function sync() {
    var box = document.querySelector('[data-eb-fbt]');
    if (!box || syncing) return;
    syncing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) { clearBox(box); return; }
        ensureMap(box, function (ok) {
          if (!ok) return; /* leave unstamped: a later sync retries */
          var map = window.EB_SIBLING_MAP || {};
          var inCart = {};
          items.forEach(function (it) { inCart[String(it.product_id)] = 1; });
          var seen = {};
          var anchors = [];
          var sibs = [];
          items.forEach(function (it) {
            var entry = map[String(it.product_id)];
            if (!entry || !entry.length) return;
            anchors.push(String(it.product_id));
            entry.forEach(function (sb) {
              var id = String(sb.i);
              if (seen[id] || inCart[id]) return;
              seen[id] = 1;
              sibs.push(sb);
            });
          });
          if (!sibs.length) { clearBox(box); return; }
          var sig = anchors.sort().join(',') + '|' + sibs.map(function (x) { return x.i; }).join(',');
          var rows = box.querySelector('[data-eb-fbt-rows]');
          if (box.getAttribute('data-eb-sig') === sig && rows && rows.children.length) {
            box.hidden = false;
            return;
          }
          renderSiblings(box, sibs, sig);
        });
      })
      .catch(function () { /* section stays as-is on any failure */ })
      .then(function () { syncing = false; });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; sync(); }, 300);
  }

  function init() {
    if (!document.querySelector('[data-eb-fbt]')) return;
    var drawerContent = document.querySelector('[data-ajax-cart-content]');
    if (drawerContent) {
      new MutationObserver(schedule).observe(drawerContent, { childList: true, subtree: true });
    }
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.EBFBT = { sync: sync };
})();
